<h2 matDialogTitle class="m-b-15">Cortar</h2>
<div mat-dialog-content class=" cut-paste-actuation m-t-10">
    <form class="form" role="form" autocomplete="off" [formGroup]="form">
        <div class="full-view">
            <label class="container-radio wauto width-100" for="EstaActuacion">Esta actuación
                <input type="radio" id="EstaActuacion" name="cutOption" formControlName="cutOption"
                    value="{{cutOptions.ESTA_ACTUACION}}">
                <span class="checkmark"></span>
            </label>
        </div>

        <div class="full-view">
            <label class="container-radio wauto" for="HastaFecha">Hasta fecha
                <input type="radio" id="HastaFecha" name="cutOption" formControlName="cutOption"
                    value="{{cutOptions.HASTA_FECHA}}">
                <span class="checkmark"></span>
            </label>

            <div class="single-date" *ngIf="form.value.cutOption === cutOptions.HASTA_FECHA">
                <mat-form-field appearance="fill">
                    <input matInput [matDatepicker]="picker" formControlName="hastaFechaField" [min]="minDate">
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <mat-error class="err-last" *ngIf="form.invalid">
                    <span *ngIf="form.get('hastaFechaField').touched && form.errors?.hastaFechaFieldRequired">
                        Obligatorio
                    </span>
                    <span *ngIf="form.get('hastaFechaField').touched && form.get('hastaFechaField').errors">
                        Invalido
                    </span>
                </mat-error>
            </div>
        </div>
    </form>
</div>
<div class="text-a-r p-t-10">
    <button class="m-r-15" mat-raised-button color="accent" (click)="cut()">Aceptar</button>
    <button mat-raised-button color="warn" (click)="close()">Cancelar</button>
</div>